<template>
  <div>
    <footer class="page-footer font-small pt-4">
      <div
        class="container-fluid text-center text-md-left"
        style="padding: 0 0 0 0;"
        v-if="false"
      >
        <h2 class="text-center mb-5 mt-5 font-weight-bold">
          What people say about Dropsmart
        </h2>

        <div class="row resposive-info-content">
          <div class="col-md mb-md-0 mb-3">
            <h5 class="font-weight-bold">Footer text 1</h5>
            <p>
              Lorem ipsum, dolor sit amet consectetur adipisicing elit. Optio
              deserunt fuga perferendis modi earum commodi aperiam temporibus
              quod nulla nesciunt aliquid debitis ullam omnis quos ipsam,
              aspernatur id excepturi hic.
            </p>
          </div>

          <hr class="clearfix w-100 d-md-none pb-3" />

          <div class="col-md mb-md-0 mb-3">
            <h5 class="font-weight-bold">Footer text 2</h5>
            <p>
              Lorem ipsum, dolor sit amet consectetur adipisicing elit. Optio
              deserunt fuga perferendis modi earum commodi aperiam temporibus
              quod nulla nesciunt aliquid debitis ullam omnis quos ipsam,
              aspernatur id excepturi hic.
            </p>
          </div>

          <hr class="clearfix w-100 d-md-none pb-3" />

          <div class="col-md mb-md-0 mb-3">
            <h5 class="font-weight-bold">Footer text 3</h5>
            <p>
              Lorem ipsum, dolor sit amet consectetur adipisicing elit. Optio
              deserunt fuga perferendis modi earum commodi aperiam temporibus
              quod nulla nesciunt aliquid debitis ullam omnis quos ipsam,
              aspernatur id excepturi hic.
            </p>
          </div>
        </div>

        <div style="background-color: #E7E7E7;" v-if="false">
          <div class="row responsive-footer-links mt-5 pt-5 pb-5">
            <div class="col-md-3 mb-md-0 mb-3">
              <h5 class="font-weight-bold">Shop</h5>

              <ul class="list-unstyled">
                <li>
                  <a href="#!" class="text-body">Lorem</a>
                </li>
                <li>
                  <a href="#!" class="text-body">Lorem</a>
                </li>
                <li>
                  <a href="#!" class="text-body">Lorem</a>
                </li>
                <li>
                  <a href="#!" class="text-body">Lorem</a>
                </li>
                <li>
                  <a href="#!" class="text-body">Lorem</a>
                </li>
                <li>
                  <a href="#!" class="text-body">Lorem</a>
                </li>
              </ul>
            </div>

            <div class="col-md-3 mb-md-0 mb-3">
              <h5 class="font-weight-bold">Sell</h5>

              <ul class="list-unstyled">
                <li>
                  <a href="#!" class="text-body">Lorem</a>
                </li>
                <li>
                  <a href="#!" class="text-body">Lorem</a>
                </li>
                <li>
                  <a href="#!" class="text-body">Lorem</a>
                </li>
                <li>
                  <a href="#!" class="text-body">Lorem</a>
                </li>
                <li>
                  <a href="#!" class="text-body">Lorem</a>
                </li>
                <li>
                  <a href="#!" class="text-body">Lorem</a>
                </li>
              </ul>
            </div>

            <div class="col-md-3 mb-md-0 mb-3">
              <h5 class="font-weight-bold">About</h5>

              <ul class="list-unstyled">
                <li>
                  <a href="#!" class="text-body">Lorem</a>
                </li>
                <li>
                  <a href="#!" class="text-body">Lorem</a>
                </li>
                <li>
                  <a href="#!" class="text-body">Lorem</a>
                </li>
                <li>
                  <a href="#!" class="text-body">Lorem</a>
                </li>
                <li>
                  <a href="#!" class="text-body">Lorem</a>
                </li>
                <li>
                  <a href="#!" class="text-body">Lorem</a>
                </li>
              </ul>
            </div>

            <div class="col-md-3 mb-md-0 mb-3">
              <h5 class="font-weight-bold">Help</h5>

              <ul class="list-unstyled">
                <li>
                  <a href="#!" class="text-body">Lorem</a>
                </li>
                <li>
                  <a href="#!" class="text-body">Lorem</a>
                </li>
                <li>
                  <a href="#!" class="text-body">Lorem</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- UPGRADE BUTTON -->
      <!-- <div class="container-fluid text-center mb-5 mt-4" v-if="customerInfo">
        <h2 v-if="!customerInfo.user.paid" class="text-center mb-5 mt-5 font-weight-bold">
          Are you ready to access all this fantastic content and more for less than 0.55 cents a day?
        </h2>
        <b-button v-if="!customerInfo.user.paid" href="https://buy.dropsmart.io/checkout?period=yearly" target="_blank" pill variant="outline-dark">Click here and upgrade</b-button>
      </div> -->

      <!-- UPGRADE BUTTON -->
      <div class="container-fluid text-center mb-5 mt-4" v-if="customerInfo">
        <h2 v-if="shouldBehaveLikeFree" class="text-center mb-5 mt-5 font-weight-bold">
          Are you ready to access all this fantastic content and more for less than 0.55 cents a day?
        </h2>
        <b-button v-if="shouldBehaveLikeFree" href="https://buy.dropsmart.io/checkout?period=yearly" target="_blank" pill variant="outline-dark">Click here and upgrade</b-button>
      </div>


      <div class="footer-copyright text-center py-3 last-footer-section">
        <div class="max-view-width">
          <div class="word-spacing" v-if="false">
            <b-icon-globe variant="dark"></b-icon-globe>
            Croatia | English(UK) | €(EUR)
          </div>
          <div class="link-spacing">
            Copyright © Dropsmart since 2016 (formerly Dropsmith)
            <a href="https://dropsmart.io/terms-and-conditions/" class="text-body" target="_blank">Terms of Use</a>
            <a href="https://dropsmart.io/privacy/" class="text-body" target="_blank">Privacy Policy</a>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "DropsmartCenterFooter",
  props: ["customerInfo", "customerLastSubscription"],
  computed: {
    shouldBehaveLikeFree() {
      if(this.customerInfo && this.customerInfo.user && !this.customerInfo.user.paid) {
        if(this.activeOrCancelingSubscription) {
          return false;
        }
        else if(this.customerInfo.user.plan.toUpperCase() === 'FREE') {
            return true;
        } else {
          if(this.customerInfo.user.plan.toUpperCase().startsWith('TRIAL')) {
            //verifying trial ended
            return this.trialEnded; 
          }
        }
        return true;
      } else {
        //paid users
        if (!this.activeOrCancelingSubscription) {
          return true
        }
      }
      return false;
    },
    trialEnded() {
      if(!this.customerInfo.user.trialEnd) {
        return false;
      }
      let now = new Date();
      let endDate = new Date(this.customerInfo.user.trialEnd);
      return now.getTime() - endDate.getTime() > 0;
    },
    activeOrCancelingSubscription() {
      if(this.customerLastSubscription && !this.customerLastSubscription.status) {
        return false;
      } else if (this.customerLastSubscription && this.customerLastSubscription.status === 'ACTIVE') {
        return true;
      } else if (this.customerLastSubscription && this.customerLastSubscription.status === 'CANCELING') {
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped lang="scss">
.last-footer-section {
  display: block;
  margin: 0 210px;
}

.max-view-width {
  max-width: 1000px;
  margin-right: -210px;
  //display: flex; 
  justify-content: space-between;
}

.word-spacing {
  word-spacing: 0.5rem;
}

.link-spacing a {
  margin-left: 1rem;
}

div.row.resposive-info-content,
div.row.responsive-footer-links {
  margin: 0 210px;
}

a.btn {
  background-color: white;
  border: none;
  font-weight: 700;
  padding: 0.8rem 3rem;

  &:hover {
    background-color: black;
  }
}

@media screen and (max-width: 1023px) {
  div.row.resposive-info-content,
  div.row.responsive-footer-links,
  .last-footer-section {
    margin: 0 1rem;
  }
}

@media screen and (max-width: 1439px) {
  .max-view-width {
    display: block;
    margin-right: 0;
  }
}

@media screen and (min-width: 1441px) {
  .max-view-width {
    max-width: 100%;
    margin-right: 0;
  }
}
</style>
